import React from 'react';
import { Flex } from '@mantine/core';
import { Text, Typography } from 'goalsetter-webapp-components';
import { ActiveGoalsEntity } from 'types/goals';
import {
  StyledMoneyInput,
  WishImage,
  iconAndTextGap,
  mainWrapperStyle,
} from './styles';
import { getGoalIcon } from 'utils/getGoalIcon';
import { formatToCurrency } from 'utils';

interface GoalItemProps {
  item: ActiveGoalsEntity;
  value: string;
  onChange: (value: string) => void;
}

export const GoalItem: React.FC<GoalItemProps> = ({
  item,
  value,
  onChange,
}) => {
  const renderGoalIcon = () => {
    if (item.wishImage && item.wishImage.startsWith('https://')) {
      return <WishImage src={item.wishImage} />;
    }
    return getGoalIcon(item.type);
  };
  return (
    <Flex
      justify="space-between"
      style={mainWrapperStyle}
    >
      <Flex
        justify="center"
        align="center"
        style={iconAndTextGap}
      >
        {renderGoalIcon()}
        <Flex direction="column">
          <Text type={Typography.GSCAPTION}>{item.prettyName}</Text>
          {item.visibilityType === 0 && (
            <Text type={Typography.GSCAPTION}>
              {formatToCurrency(`${item.publicAchievedAmount.toFixed(2)}`, '$')}{' '}
              Saved
            </Text>
          )}
        </Flex>
      </Flex>
      <StyledMoneyInput
        id={item.rid}
        placeholder="$0.00"
        label=""
        value={value}
        onChangeValue={onChange}
        maxAmount={10000}
        minAmount={0}
      />
    </Flex>
  );
};
